import React from 'react';
import { Link } from "react-router-dom";

const Steps = (props: any) => {

  const breadcrumbs: any[] = [];

  props.links.forEach((data: any, id: number, array: []) => {
    let classNames = "";
    let stepClassNames = "";

    if (id == 0){
       stepClassNames += ' steper-first';
    }

    if (id == array.length - 1){
       stepClassNames += ' steper-last';
    }

    let link = <Link to={data.link}><i className={"mt-1 fa-solid fa-circle steper text-secondary" + stepClassNames}></i></Link>;
    if( !data.active ){
      classNames += ' active';
      link = <div><i className={"steper-active fa-solid fa-circle-dot steper text-primary" + stepClassNames}></i></div>;
    }

    breadcrumbs.push(link)
  })

  return (
    <div className="mb-5 pb-5">
      <div className="row">
        <div className="mx-auto col-8 col-lg-4 d-flex justify-content-between steper-border">
          {breadcrumbs}
        </div>
      </div>
    </div>
  )

}

export default Steps
